import { render } from "./PaiementAmbulantPage.vue?vue&type=template&id=b759ba9a&ts=true"
import script from "./PaiementAmbulantPage.vue?vue&type=script&lang=ts"
export * from "./PaiementAmbulantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__